/* eslint-disable import/order */
/* eslint-disable import/no-unresolved */
import { Routes, Route } from 'react-router-dom';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import HomePage from './Pages/homePage/HomePage';
import SehatAtoZ from './Pages/sehatAtoZ/SehatAtoZ';
import HealthCheck from './Pages/healthCheck/HealthCheck';
import FindADoctor from './Pages/findADoctor/FindADoctor';
import DiscoverWellness from './Pages/discoverWellness/DiscoverWellness';
import DiscoverWellnessInnerPage from './Pages/discoverWellnessInnerPage/DiscoverWellnessInnerPage';
import ArticleInnerPage from './Pages/articleInnerPage/ArticleInnerPage';
import HealthCheckHistory from './Pages/healthCheckHistory/HealthCheckHistory';
import HealthCheckSubscription from './Pages/healthCheckHistory/healthCheckSubscription/HealthCheckSubscription';
import StartVitalScan from './Pages/healthCheckHistory/startVitalScan/StartVitalScan';
import ScanStarted from './Pages/healthCheckHistory/scanStarted/ScanStarted';
import Subscription from './Pages/healthCheckHistory/subscription/Subscription';
import AddFamilyMember from './Pages/healthCheckHistory/addFamilyMember/AddFamilyMember';
import EditFamilyMember from './Pages/healthCheckHistory/editFamilyMember/EditFamilyMember';
import UpdateProfile from './Pages/healthCheckHistory/updateProfile/UpdateProfile';
import InstantConsultant from './Pages/healthCheckHistory/instantConsultant/InstantConsultant';
import FamilyMembers from './Pages/healthCheckHistory/familyMembers/FamilyMembers';
import UploadMedicalRecordes from './Pages/healthCheckHistory/uploadMedicalRecordes/UploadMedicalRecordes';
import MedicalRecordes from './Pages/healthCheckHistory/medicalRecordes/MedicalRecordes';
import AddEditMedicalRecords from './Pages/healthCheckHistory/addEditMedicalRecords/AddEditMedicalRecords';
import ViewMedicalRecords from './Pages/healthCheckHistory/viewMedicalRecords/ViewMedicalRecords';
import BookAnAppointment from './Pages/healthCheckHistory/doctorAppointment/bookAnAppointment/BookAnAppointment';
import BookAnAppointmentDetails from './Pages/healthCheckHistory/doctorAppointment/bookAnAppointmentDetails/BookAnAppointmentDetails';
import Dashboard from './Pages/healthCheckHistory/dashboard/Dashboard';
import HealthCheckReuslt from './Pages/healthCheckHistory/healthCheckReuslt/HealthCheckReuslt';
import FindADoctorViewAllSpecailist from './Pages/findADoctorViewAllSpecailist/FindADoctorViewAllSpecailist';
import DoctorListing from './Pages/doctorListing/DoctorListing';
// import DoctorDetail from './Pages/doctorDetail/DoctorDetail';
import ReviewAndBook from './Pages/checkoutFlow/reviewAndBook/ReviewAndBook';
import SelectpaymentMethod from './Pages/checkoutFlow/selectpaymentMethod/SelectpaymentMethod';
import PaymentConfimation from './Pages/checkoutFlow/paymentConfimation/PaymentConfimation';
import SubscriptionPage from './Pages/subscriptionPage/SubscriptionPage';
import ConsultNow from './Pages/consultNow/ConsultNow';
import PrivacyPolicyPage from './Pages/privacyPolicyPage/PrivacyPolicyPage';
import DoctorDetail from './Pages/findADoctor/doctorDetail/DoctorDetail';
import {
  PreLogin,
  LoginWithPhone,
  Signup,
  OtpWhenLoggingIn,
  AccountCreated,
  FewMoreDetail
} from './Pages/login';
import 'react-select-2/dist/css/react-select-2.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/style.css';
import HomePageUrdu from './Pages/homePageUrdu/HomePageUrdu';
import { getUsers } from './redux/Actions/TestActions';
import { getUser } from './api/user';
import Registeration from './Pages/Registeration/Registeration'
import Thankyou from './Pages/Thankyou/Thankyou'
import Otp1 from './Pages/Otp1/Otp1'
import Otp2 from './Pages/Otp2/Otp2'





function App() {
  const dispatch = useDispatch();

  const getAllUsers = async () => {
    const response = await getUser();
    dispatch(getUsers(response));
  };

  useEffect(() => {
    // const result = API.get('todos/5');
    // console.log(result);
    getAllUsers();
  }, []);

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/homepageUrdu" element={<HomePageUrdu />} />
      <Route path="/sehatatoz" element={<SehatAtoZ />} />
      <Route path="/healthCheck" element={<HealthCheck />} />
      <Route path="/findADoctor" element={<FindADoctor />} />
      <Route path="/doctorListing" element={<DoctorListing />} />
      {/* <Route path="/doctorDetail" element={<DoctorDetail />} /> */}
      <Route path="/reviewAndBook" element={<ReviewAndBook />} />
      <Route path="/selectpaymentMethod" element={<SelectpaymentMethod />} />
      <Route path="/paymentConfimation" element={<PaymentConfimation />} />
      <Route path="/subscriptionPage" element={<SubscriptionPage />} />
      <Route path="/consultNow" element={<ConsultNow />} />
      <Route path="/privacyPolicyPage" element={<PrivacyPolicyPage />} />
      <Route path="/doctorDetail" element={<DoctorDetail />} />
      <Route
        path="/findADoctorViewAllSpecailist"
        element={<FindADoctorViewAllSpecailist />}
      />
      <Route path="/discoverWellness" element={<DiscoverWellness />} />
      <Route
        path="/discoverWellnessInnerPage"
        element={<DiscoverWellnessInnerPage />}
      />
      <Route path="/articleInnerPage" element={<ArticleInnerPage />} />
      <Route path="/preLogin" element={<PreLogin />} />
      <Route path="/loginWithPhone" element={<LoginWithPhone />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/otpWhenLoggingIn" element={<OtpWhenLoggingIn />} />
      <Route path="/accountCreated" element={<AccountCreated />} />
      <Route path="/fewMoreDetail" element={<FewMoreDetail />} />
      <Route path="/healthCheckHistory" element={<HealthCheckHistory />} />
      <Route
        path="/healthCheckSubscription"
        element={<HealthCheckSubscription />}
      />
      <Route path="/startVitalScan" element={<StartVitalScan />} />
      <Route path="/scanStarted" element={<ScanStarted />} />
      <Route path="/subscription" element={<Subscription />} />
      <Route path="/addFamilyMember" element={<AddFamilyMember />} />
      <Route path="/editFamilyMember" element={<EditFamilyMember />} />
      <Route path="/updateProfile" element={<UpdateProfile />} />
      <Route path="/familyMembers" element={<FamilyMembers />} />
      <Route path="/instantConsultant" element={<InstantConsultant />} />
      <Route
        path="/uploadMedicalRecordes"
        element={<UploadMedicalRecordes />}
      />
      <Route path="/medicalRecordes" element={<MedicalRecordes />} />
      <Route
        path="/addEditMedicalRecords"
        element={<AddEditMedicalRecords />}
      />
      <Route path="/viewMedicalRecords" element={<ViewMedicalRecords />} />
      <Route path="/bookAnAppointment" element={<BookAnAppointment />} />
      <Route
        path="/bookAnAppointmentDetails"
        element={<BookAnAppointmentDetails />}
      />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/healthCheckReuslt" element={<HealthCheckReuslt />} />
      <Route path="/Registeration" element={<Registeration />} />
      <Route path="/Thankyou" element={<Thankyou />} />
      <Route path="/Otp1" element={<Otp1 />} />
      <Route path="/Otp2" element={<Otp2 />} />




    </Routes>
  );
}

export default App;
